module.exports = __webpack_public_path__ + "static/img/SupandSerBanner.2ce500c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SupandSerBanner.png
// module id = qiS+
// module chunks = 1